import React from "react";
import { useLocation } from "react-router-dom";
function UseQuery() {
  const { search } = useLocation();

  const querySearch = React.useMemo(
    () => new URLSearchParams(search),
    [search]
  );

  const query = Object.fromEntries(querySearch.entries());

  return {
    query: query
  };
}

export default UseQuery;
